import React, { ReactElement } from 'react';
import { Pagination as PaginationComponent } from 'b2b-components/theme/components/Pagination';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ComponentType, Props } from './';

const Pagination: ComponentType = ({
  className,
  handlePaginationClick,
  page,
  total,
}: Props): ReactElement => {
  const t = useTranslate();

  const text = {
    previousPage: t('Previous Page'),
    nextPage: t('Next Page'),
  };

  return (
    <PaginationComponent
      className={className}
      current={page}
      onClick={handlePaginationClick}
      text={text}
      total={total}
    />
  );
};

export { Pagination };
